/* code for show only 22 alphabets of produts

 
/assets/custom.js  |  instant product-title truncate */
(function () {
  const sel = '.product-card .text-block p'; // the exact title node
  const max = 30;

  function trim(node) {
    const txt = node.textContent.trim();
    if (txt.length > max) node.textContent = txt.slice(0, max) + '…';
  }

  /* 1️⃣  cards already in the initial HTML */
  document.querySelectorAll(sel).forEach(trim);

  /* 2️⃣  cards injected later via JS (quick-view, filters, etc.) */
  new MutationObserver(muts => {
    muts.forEach(m =>
      m.addedNodes.forEach(n => {
        if (n.nodeType !== 1) return;                 // skip text nodes
        if (n.matches && n.matches(sel)) return trim(n);
        n.querySelectorAll && n.querySelectorAll(sel).forEach(trim);
      })
    );
  }).observe(document, {childList: true, subtree: true});
})(); 


/* code end show only 22 alphabets of produts

 
/assets/custom.js  |  instant product-title truncate */






/* Code start for show text (Add 2nd for ₹257) below add to cart btn  for T-Shirt bra Cartegories only


document.addEventListener('DOMContentLoaded', function() {
// Check if the product title contains 'INGRID T-Shirt Bra'
var productTitle = document.querySelector('h4');
var isTShirtBraProduct = productTitle && productTitle.textContent.includes('INGRID T-Shirt Bra');

if (isTShirtBraProduct) {
var addToCartButton = document.querySelector('.add-to-cart-button');
if (addToCartButton) {
// Create the main custom text element
var customText = document.createElement('span');
customText.className = 'custom-text-below-add-to-cart';
customText.style.marginTop = '5px';
customText.style.fontSize = '18px';
customText.style.textAlign = 'left';
customText.style.display = 'block';

// Create the text parts
var textPart = document.createTextNode('Add ');
var numberSuperscriptContainer = document.createElement('span'); // New container for "2nd"
var numberPart = document.createTextNode('2');
var superscriptPart = document.createElement('sup');
superscriptPart.textContent = 'nd';

// Append number and superscript to the new container
numberSuperscriptContainer.appendChild(numberPart);
numberSuperscriptContainer.appendChild(superscriptPart);

var forText = document.createTextNode(' for ');
var pricePart = document.createElement('span');
pricePart.textContent = '₹257';
pricePart.style.color = '#dd235c';
pricePart.style.fontWeight = 'bold';
pricePart.style.fontFamily = 'Roboto, sans-serif';

// Append all parts to the main custom text element
customText.appendChild(textPart);
customText.appendChild(numberSuperscriptContainer);
customText.appendChild(forText);
customText.appendChild(pricePart);

// Append the custom text to the form containing the Add to Cart button
 addToCartButton.closest('form').appendChild(customText);
 }
 }
 });

 /* Code end for show text (Add 2nd for ₹257) below add to cart btn  for T-Shirt bra Cartegories only*/





 

 
/* Smallest working version for cart price fix   */
(() => {
  const updatePrices = () => {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        document.querySelectorAll('.cart-items__table-row[data-key]').forEach(row => {
          const item = cart.items.find(it => it.key === row.dataset.key);
          if (!item) return;
          const price = new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: cart.currency,
          }).format(item.line_price / 100);
          const el = row.querySelector('.cart-items__price text-component') || row.querySelector('.cart-items__price');
          el && (el.textContent = el.getAttribute('value') ? (el.setAttribute('value', price), price) : price);
        });
      })
      .catch(e => console.error('Cart price update failed:', e));
  };
  const observeCart = () => {
    const root = document.querySelector('.cart-drawer__items, .cart-items__wrapper');
    if (!root) return;
    new MutationObserver(updatePrices).observe(root, { childList: true, subtree: true });
    updatePrices();
  };
  document.readyState !== 'loading' ? observeCart() : document.addEventListener('DOMContentLoaded', observeCart);
  document.addEventListener('click', e => {
    e.target.closest('[on\\:click="/open"], [data-open-cart]') && setTimeout(updatePrices, 180);
  });
})();